<template>
    <div :class="[{'stripe': stripe, 'hoverFlat': hoverFlat}, `vs-table-${color}`]"
            class="vs-component vs-con-table">
        <!-- header -->
        <header class="header-table vs-table--header">
            <slot name="header"></slot>
            <div v-if="search" class="con-input-search vs-table--search">
                <input v-model="searchx" :placeholder="placeholder" class="input-search vs-table--search-input" type="text">
                <vs-icon icon="search"></vs-icon>
                <x-circle-icon size="1.5x" class="custom-class clear-icon"
                               v-show="getSearchText.length" @click="clearInput" />
            </div>
        </header>
        <div class="con-tablex vs-table--content">
            <div :style="styleConTbody" class="vs-con-tbody vs-table--tbody ">
                <table ref="table" class="vs-table vs-table--tbody-table">
                    <thead ref="thead" class="vs-table--thead">
                    <tr>
                        <th v-if="multiple || hasExpadableData" class="td-check">
                            <span v-if="multiple" class="con-td-check">
                                <vs-checkbox
                                      :key="isCheckedLine ? 'remove' : 'check'"
                                      :icon="isCheckedLine ? 'remove' : 'check'"
                                      :checked="isCheckedMultiple"
                                      size="small"
                                      @click.native="changeCheckedMultiple"/>
                            </span>
                        </th>
                        <slot name="thead"></slot>
                    </tr>
                    </thead>
                    <slot :data="datax"></slot>
                </table>
            </div>
            <div v-if="isNoData" class="not-data-table vs-table--not-data">
                {{ noDataText }}
            </div>

            <div v-if="showPagonaton && pagination && isUsingPage && getCurrentTotalPage > 1" class="con-pagination-table vs-table--pagination">
                <gc-vs-pagination-nosize
                        v-model="currentx"
                        :total="searchx && !localSST ? getTotalPagesSearch : getTotalPages"
                        :description-items="descriptionItems"
                        :max-items="localPager.size"
                        :size-array="queriedResults.length"
                        :description="description"
                        :max="getPageSize"
                        :goto="true"
                >
                </gc-vs-pagination-nosize>
            </div>
        </div>
    </div>
</template>

<script>

    /**
     * Version:     2.0
     * Note:        精简了属性定义，测试 排序、搜索、翻页、SST 和 All-Data 都可正常显示
     * Date:        2020-08-30
     */

    import { XCircleIcon } from 'vue-feather-icons'

    export default {
        name: "gc-cmp-vs-table",
        components: { XCircleIcon },
        props: {
            placeholder: {
                type: String,
                default:''
            },
            value:{},
            color: {
                default:'primary',
                type: String
            },
            noDataText: {
                default: '暂无数据',
                type: String
            },
            stripe:{
                default: false,
                type: Boolean
            },
            hoverFlat:{
                default: false,
                type: Boolean
            },
            maxHeight:{
                default: 'auto',
                type: String
            },
            multiple:{
                default: false,
                type: Boolean
            },
            data:{
                default: null,
            },
            notSpacer:{
                default:false,
                type:Boolean
            },
            search:{
                default: false,
                type: Boolean
            },
            description:{
                default: false,
                type: Boolean
            },
            descriptionItems:{
                default: () => [],
                type: Array
            },
            pager: {
                type: Object,
                required: false,
                default: () => {}
            },
            pageSize: {
                type: [Number, String],
                required: false,
                default: 7
            },
            onlyClickCheckbox: {
                type: Boolean,
                default: false
            },
            pagination: {
                type: Boolean,
                default: true
            },
        },
        data: () => ({
            showPagonaton: true,
            localPager: {
                page: 1,
                last: 1,  // 最大页数
                total: 0,
                size: 5
            },
            localSST: false,
            headerWidth: '100%',
            trs: [],
            datax: [],
            searchx: '',
            currentx: 1,
            hasExpadableData: false,
            currentSortKey: null,
            currentSortType: null
        }), // data
        watch: {
            pager: {
                handler(val) {
                    // console.log(['out-change-pager', this.searchx, val]);
                    this.updatePageParams(val);
                },
                deep: true
            },
            currentx(page) {
                if(this.localSST) {
                    this.$emit('change-page', {page: this.currentx, search: this.searchx + ''});
                } else {
                    this.localPager.page = page;
                    this.currentx = page
                    this.loadData()
                }
            },
            data(val) {
                this.loadData()
                this.$nextTick(() => { if(this.datax.length > 0) { this.changeTdsWidth() } })
            },
            searchx() {
                if(this.localSST) {
                    this.$emit('search', {page: 1, search: this.searchx + ''})
                } else {
                    this.currentx = 1;
                    this.loadData();
                    this.$emit('change-page', {page: this.currentx, search: this.searchx + ''});
                }
            }
        },  // watch
        computed: {
            getPageSize() {
                return  parseInt(this.pageSize);
            },
            getSearchText() {
                let ret = '';
                if (this.searchx !== null && this.searchx.length > 0) {
                    ret = this.searchx + '';
                }
                return ret;
            },
            pageReader() {
                return  this.localPager;
            },
            getTotalPages() {
                if(this.localSST) {
                    return Math.ceil(this.pageReader.total / this.pageReader.size)
                } else {
                    return Math.ceil(this.data.length / this.pageReader.size)
                }
            },
            getTotalPagesSearch() {
                if(this.localSST) {
                    return  this.localPager.last;
                } else {
                    return Math.ceil(this.queriedResults.length / this.pageReader.size)
                }
            },
            queriedResults() {
                let queriedResults = this.data
                if(this.searchx && this.search) {
                    let dataBase = this.data
                    queriedResults = dataBase.filter((tr)=>{
                        let values = this.getValues(tr).toString().toLowerCase()
                        return values.indexOf(this.searchx.toLowerCase()) != -1
                    })
                }
                return queriedResults
            },
            isNoData() {
                if(typeof(this.datax) == Object) {
                    return this.datax? Object.keys(this.datax).length == 0:false && this.search
                } else {
                    return this.datax?this.datax.length == 0:false && this.search
                }
            },
            isCheckedLine () {
                let lengthx = this.data.length
                let lengthSelected = this.value.length
                return lengthx !== lengthSelected
            },
            isCheckedMultiple () {
                return this.value.length > 0
            },
            styleConTbody () {
                return {
                    maxHeight: this.maxHeight,
                    overflow: this.maxHeight != 'auto'?'auto':null
                }
            },
            getCurrentTotalPage() {     // 计算搜索和非搜索情况下的实际总页数
                let ret = 1;
                if (this.search && this.searchx.length > 0) {
                    ret = this.getTotalPagesSearch;
                } else {
                    ret = this.getTotalPages;
                }
                return ret;
            },
            isUsingPage() {
                // 使用分页的条件
                // [1] 服务器返回带 pager 字段，并且页码数量 > 1
                // [2] page.size 大于 0 ，data.length 大于 page.size
                let ret = false;
                if (this.localPager.last > 1) {
                    ret = true;
                }
                if (this.data && this.data.length > 0 && this.localPager.size > 0) {
                    if (this.data.length > this.localPager.size) {
                        ret = true;
                    }
                }
                return ret;
            }
        },  // computed
        methods:{
            changePage(){
                this.localPager.page = 1
                this.$forceUpdate()
            },
            clearInput() {
                this.searchx = '';
            },
            updatePageParams(pager) {  // 计算 prop-pager 来更新本地翻页相关的变量
                // console.log(['params', pager]);
                if (undefined === pager) {return;}
                this.localPager.page  = Math.ceil(pager.page || 1);
                this.localPager.last  = Math.ceil(pager.last || 1);
                this.localPager.size  = Math.ceil(pager.size || this.localPager.size);
                this.localPager.total  = Math.ceil(pager.total || 0);
                this.localSST = this.localPager.total > 1;  // 服务器端返回数据带 pager 字段，并且总数大于 0 ，才设置服务器翻页标志
                this.currentx = this.localPager.page || 1;
            },
            loadData() {
                let max = 0;
                if (this.localSST) {
                    // 这是分页去加载当前 page 数据，因此永远都是 0-20
                    max = Math.ceil(1 * this.pageReader.size)
                } else {
                    // 这是一次性加载全部数据
                    max = Math.ceil(this.pageReader.page * this.pageReader.size)
                }
                let min = max - this.pageReader.size
                if(!this.searchx || this.localSST) {
                    this.datax = this.isUsingPage ? this.getItems(min, max) : this.sortItems(this.data) || [];
                } else {
                    this.datax = this.isUsingPage ? this.getItemsSearch(min, max) : this.getItemsSearch(min, max) || []
                }
            },
            getItems(min, max) {
                let dataBase = this.sortItems(this.data);
                // console.log(['getItems', min, max, dataBase]);
                let items = []
                dataBase.forEach((item, index) => {
                    if(index >= min && index < max) {
                        items.push(item)
                    }
                })
                return items
            },
            sortItems(data) {
                data = data || [];
                const { currentSortKey, currentSortType } = this;
                function compare(a,b) {
                    if (a[currentSortKey] < b[currentSortKey])
                        return currentSortType == 'desc'?1:-1;
                    if (a[currentSortKey] > b[currentSortKey])
                        return currentSortType == 'desc'?-1:1;
                    return 0;
                }
                return currentSortType !== null ? [...data].sort(compare) : [...data];
            },
            getItemsSearch(min, max) {
                const search = this.normalize(this.searchx);
                return this.sortItems(this.data).filter((tr)=>{
                    return this.normalize(this.getValues(tr).toString()).indexOf(search) != -1
                }).filter((_, index) => {
                    return (index >= min && index < max);
                });
            },
            sort(key, sortType) {
                this.currentSortKey = key;
                this.currentSortType = sortType;
                if(this.localSST) {
                    this.$emit('sort', key, sortType)
                    return
                }
                this.loadData();
            },
            normalize(string) {
                return string.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            },
            getValues: function getValues(obj) {
                function flattenDeep(val) {
                    return Object.values(val || []).reduce((acc, val) => (typeof val === 'object') ? acc.concat(flattenDeep(val)) : acc.concat(val), []);
                }
                return flattenDeep(obj).filter(function (item) {
                    return (typeof item === 'string') || (typeof item === 'number');
                });
            },
            changeCheckedMultiple () {
                let lengthx = this.data.length
                let lengthSelected = this.value.length
                let selectedx = (lengthx - lengthSelected)
                if (selectedx == 0) {
                    this.$emit('input', [])
                } else {
                    this.$emit('input', this.data)
                }
            },
            handleCheckbox(tr) {
                if(this.multiple && this.onlyClickCheckbox){
                    let val = this.value.slice(0)
                    if(val.includes(tr)) {
                        val.splice(val.indexOf(tr),1)
                    } else {
                        val.push(tr)
                    }
                    this.$emit('input', val)
                    this.$emit('selected', tr)
                }
            },
            clicktr (tr, isTr) {
                if(this.multiple && isTr && !this.onlyClickCheckbox){
                    let val = this.value.slice(0)
                    if(val.includes(tr)) {
                        val.splice(val.indexOf(tr),1)
                    } else {
                        val.push(tr)
                    }
                    this.$emit('input', val)
                    this.$emit('selected', tr)
                } else if (isTr && !this.onlyClickCheckbox) {
                    this.$emit('input', tr)
                    this.$emit('selected', tr)
                }
            },
            dblclicktr (tr, isTr) {
                if (isTr) { this.$emit('dblSelection',tr) }
            },
            listenerChangeWidth () {
                this.headerWidth = `${this.$refs.table.offsetWidth}px`
                this.changeTdsWidth()
            },
            changeTdsWidth() {
                if(!this.value) return
                let tbody = this.$refs.table.querySelector('tbody')
                // Adding condition removes querySelector none error - if tbody isnot present
                if(tbody) {
                    let trvs = tbody.querySelector('.tr-values')
                    if (trvs === undefined || trvs === null ) return
                    let tds = trvs.querySelectorAll('.td')
                    let tdsx = []
                    tds.forEach((td, index) => {
                        tdsx.push({index: index, widthx: td.offsetWidth})
                    });
                    let colgrouptable = this.$refs.colgrouptable
                    if (colgrouptable !== undefined && colgrouptable !== null ) {
                        let colsTable = colgrouptable.querySelectorAll('.col')
                        colsTable.forEach((col, index) => {
                            col.setAttribute('width', tdsx[index].widthx)
                        });
                    }
                } // if
            } // changeTdsWidth
        }, // methods

        mounted () {
            window.addEventListener('resize', this.listenerChangeWidth)
            this.loadData()

            // this.$nextTick(() => {
            //   if(this.datax.length > 0) {
            //     this.changeTdsWidth()
            //   }
            // })
        },
        created() {
            this.updatePageParams(this.pager);
        },
        destroyed () {
            window.removeEventListener('resize', this.listenerChangeWidth)
        },
    }
</script>
